import { render, staticRenderFns } from "./ComicsScreen.vue?vue&type=template&id=4f6c8290&"
import script from "./ComicsScreen.vue?vue&type=script&lang=js&"
export * from "./ComicsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports